import {FETCH_AI_FUNCTIONS, CLEAN_AI_FUNCTIONS, DELETE_AI_FUNCTION} from '../actions/types';

const AI_FUNCTIONS_DEFAULT_STATE = {};

const AiFunctionsReducer = (state = AI_FUNCTIONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_FUNCTIONS:
            return payload;

        case CLEAN_AI_FUNCTIONS:
        case DELETE_AI_FUNCTION:
            return AI_FUNCTIONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiFunctionsReducer;
